'use strict';
var React = require('react');

var TestProjects = React.createClass({
  propTypes: {
    openApp: React.PropTypes.func.isRequired
  },
  render: function () {
    var projects = [
      'data/未命名.mp',
      'data/ae24d2fa-795b-46a3-a6af-f076a65c0a4c.zip',
      'data/cprr2pUQE0.zip',
      'data/DLPv6.0管理端1.mp',
      'data/新增地址.mx',
      'data/产品原型-完成版.mp',
      'data/1897cd25-60f4-4fbb-90a8-7e1fd3daef4e.zip',
      'data/def2823f-fc28-41fa-a647-94b230d774bf.mp',
      'data/16ddec2e-612d-4aab-a0e2-d5933c502122.zip',
      'data/弹出菜单.mp',
      'data/测试10.mp',
      'data/app.mp',
      'data/下拉列表框.mp',
      'data/21e4e324-dd3c-4868-ab86-fc80dade3af6.zip',
      'data/课程详情.mp',
      'data/bug.mp',
      'data/bestvane.mp',
      'data/free.mp',
      'data/web.mp',
      'data/mobile.mp',
      'data/WF_H&STablet_v1.0.mp',
      'data/49e67b5e-13cb-4fb3-bde2-bedea38ca095.zip'
    ];

    return (
      <div className='projects-list'>
        <h4>测试项目</h4>
        <ul>
          {projects.map(function (project) {
            return (
              <li key={project} onClick={this.openApp.bind(this, project)}>{project.replace('data/', '')}</li>
            );
          }, this)}
        </ul>
      </div>
    )
  },
  openApp: function (app) {
    this.props.openApp(app);
  }
});

module.exports = TestProjects;



/** WEBPACK FOOTER **
 ** ./src/views/Dev/TestProjects.jsx
 **/